<app-form-input *ngIf="!displayStar" [parentForm]="parentForm" [disabled]="disabled" [value]="objetPrincipal?.classPrincipale"
  [label]="step3.classPrincipale" [type]="'autocomplete'" [rule]="'required|pattern_17'" 
  [errorMessage]="{'pattern' : 'ctr_1113'}" [autoCompleteType]="'CPV'" [autoCompleteTypeIndex]="1"
  [name]="getUid() + '_SepAtt_classPrincipale'">
</app-form-input>
<app-form-input *ngIf="displayStar" [parentForm]="parentForm" [disabled]="disabled" 
  [value]="objetPrincipal?.classPrincipale" [label]="step3.classPrincipale" [type]="'autocompleteWithStar'"
  [rule]="'required|pattern_17'" [errorMessage]="{'pattern' : 'ctr_1113'}" [autoCompleteType]="'CPV'" [autoCompleteTypeIndex]="1"
  [name]="getUid() + '_SepAtt_classPrincipale'" [preferenceType]="typeCpv"
  (preferenceSelected)="chargeDonneePreference($event)">
</app-form-input>
